import  gql  from 'graphql-tag'

export const EDIT_SETTINGS = gql`mutation systemSettings($input: SystemSettingsMutationInput!){
    systemSettings(input: $input){
        systemSettings{
            versionId
            idleTime
        }
        errors{
            field
            messages
        }
    }
}`;